import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        config: {},
        appMessage: '',
        appLoaderShow: null,
        sourceRoute: null,
        scrollBottom: 0,
        routerParams: {
            Uid: 0,
            ShareCode: 0
        },
        staffData: null,
        animation: '',
        diamSearch: {},
        uid: 0,
        currentPage: '',
        hasSearch: false,
        ossPath: ''
    },
    mutations: {
        onChangeAppMessage (state, value) {
            state.appMessage = value
        },
        onChangeSourceRoute (state, value) {
            state.sourceRoute = value
        },
        onChangeAppLoaderShow (state, value) {
            state.appLoaderShow = value
        },
        onChangeRouterParams (state, value) {
            state.routerParams = value
        },
        onChangeScrollBottom (state, value) {
            state.scrollBottom = value
        },
        onChangeStaffData (state, value) {
            state.staffData = value
        },
        onChangeRouterParamsPush (state, value) {
            if (_.isPlainObject(value)) {
                state.routerParams = Object.assign(state.routerParams, value)
            }
        },
        onChangeAnimation (state, value) {
            state.animation = value
        },
        onChangeDiamSearch (state, value) {
            state.diamSearch = value
        },
        onChangeUid (state, value) {
            state.uid = value
        },
        onChangeCurrentPage (state, value) {
            state.currentPage = value
        },
        onChangeHasSearch (state, value) {
            state.hasSearch = value
        },
        onChangeConfig (state, value) {
            state.config = value
        },
        onChangeOssPath (state, value) {
            state.ossPath = value
        }
    }
})



// WEBPACK FOOTER //
// ./src/store.js